// extracted by mini-css-extract-plugin
export default {"text_header":"common_text_header__9o7Yf","text_content--SECOND":"common_text_content--SECOND__0gPVe","text_content--FOURTH":"common_text_content--FOURTH__CGkS2"};